import React from 'react';
import {ContentWrapper, InfoOriginalNameWrapper, InfoTextWrapper, TextWrapper} from './FolderBasicData.style';
import {t} from 'i18next';
import {formatDate, formatSize} from '../../../utils';
import {StorageObject} from '../../../models/StorageObject';
import {generateIdentifier} from '../../../utils/IdentityUtils';
import {TemplatePropertySettings} from '../../../models/TemplatePropertySettings';
import {isVisibleComponent} from '../../../utils/TemplateUtils';
import {
    STORAGE_OBJECT_NAME,
    STORAGE_OBJECT_OBJECT_METADATA,
    STORAGE_OBJECT_OBJECT_METADATA_DATE_CREATED,
    STORAGE_OBJECT_OBJECT_METADATA_DATE_UPDATED,
    STORAGE_OBJECT_OBJECT_METADATA_FILE_COUNT,
    STORAGE_OBJECT_OBJECT_METADATA_FOLDER_COUNT,
    STORAGE_OBJECT_TOTAL_SIZE
} from '../../../init/storage_object_constants';

export interface FolderBasicDataProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly language: string;
    readonly item: StorageObject;
}

export const FolderBasicData: React.VFC<FolderBasicDataProps> = (props) => {
    return (
        <ContentWrapper id={generateIdentifier()}>
            {isVisibleComponent(STORAGE_OBJECT_NAME, props.templatePropertySettings) &&
                <InfoOriginalNameWrapper id={generateIdentifier()}>
                    <TextWrapper id={generateIdentifier()}>
                        {t('FOLDER_META_DATA_DIALOG_ORIGINAL_NAME_INFO_TEXT', {name: props.item.name})}
                    </TextWrapper>
                </InfoOriginalNameWrapper>
            }
            {((isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                        && (isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_FOLDER_COUNT, props.templatePropertySettings)
                            || isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_FILE_COUNT, props.templatePropertySettings)))
                    || isVisibleComponent(STORAGE_OBJECT_TOTAL_SIZE, props.templatePropertySettings)) &&
                <InfoTextWrapper id={generateIdentifier()}>
                    {isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_FOLDER_COUNT, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('FOLDER_META_DATA_DIALOG_FOLDER_COUNT_INFO_TEXT', {count: (props.item.metadata.folderCount ? props.item.metadata.folderCount : 0)})}
                        </TextWrapper>
                    }
                    {isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_FILE_COUNT, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('FOLDER_META_DATA_DIALOG_FILE_COUNT_INFO_TEXT', {count: (props.item.metadata.fileCount ? props.item.metadata.fileCount : 0)})}
                        </TextWrapper>
                    }
                    {isVisibleComponent(STORAGE_OBJECT_TOTAL_SIZE, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('FOLDER_META_DATA_DIALOG_TOTAL_SIZE_INFO_TEXT', {size: formatSize(props.item.totalSize)})}
                        </TextWrapper>
                    }
                </InfoTextWrapper>
            }
            <div id={generateIdentifier()}/>
            {(isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                    && (isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_CREATED, props.templatePropertySettings)
                        || isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_UPDATED, props.templatePropertySettings))) &&
                <InfoTextWrapper id={generateIdentifier()}>
                    {isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_CREATED, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('FOLDER_META_DATA_DIALOG_DATE_CREATED_INFO_TEXT', {date: formatDate(props.language, props.item.metadata.dateCreated)})}
                        </TextWrapper>
                    }
                    {isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_DATE_UPDATED, props.templatePropertySettings) &&
                        <TextWrapper id={generateIdentifier()}>
                            {t('FOLDER_META_DATA_DIALOG_DATE_UPDATED_INFO_TEXT', {date: formatDate(props.language, props.item.metadata.dateUpdated)})}
                        </TextWrapper>
                    }
                </InfoTextWrapper>
            }
        </ContentWrapper>
    );
};
